import { Link } from "react-router-dom";

interface MangaCardProps {
  id: string;
  title: string;
  author: string;
  cover: string;
  tags: string[];
  rating: number;
  status: string;
  category: string;
}

export default function MangaCard({ id, title, author, cover, tags, rating, status, category }: MangaCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md">
          {rating}
        </div>
        <div className="absolute top-2 left-2 bg-background-50/90 text-foreground-950 text-xs px-2 py-1 rounded-md">
          {status}
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate">{title}</h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{author}</p>
        <div className="flex items-center gap-1 mt-2 flex-wrap">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}